// extracted by mini-css-extract-plugin
module.exports = {"SecurePaymentsFooter":"SecurePaymentsFooter_SecurePaymentsFooter__xtOsu"};